"use strict";
import { authConstants, commonConstants } from "../_constants";

const INITIAL_SERVER_SUCCESS_MESSAGE_STATE = {
  show: false,
  messageObj: {},
};

export function successMessageReducer(
  state = INITIAL_SERVER_SUCCESS_MESSAGE_STATE,
  action,
) {
  switch (action.type) {
    case commonConstants.SHOW_SUCCESS_SERVER_MESSAGE:
      return {
        show: true,
        messageObj: { ...action.payload },
      };

    case commonConstants.HIDE_SUCCESS_SERVER_MESSAGE:
      return INITIAL_SERVER_SUCCESS_MESSAGE_STATE;
  }

  return state;
}

const INITIAL_SERVER_ERROR_MESSAGE_STATE = {
  show: false,
  messages: [],
  statusCodes: [],
  customErrors: [],
  showConfirm: false,
};

export function errorMessageReducer(
  state = INITIAL_SERVER_ERROR_MESSAGE_STATE,
  action,
) {
  switch (action.type) {
    case commonConstants.SHOW_ERROR_SERVER_MESSAGE:
      return {
        ...state,
        customErrors: [],
        show: true,
        messages: [
          ...state.messages,
          action.payload.message,
          action.payload.message2 != undefined ? action.payload.message2 : null,
        ],
        statusCodes: [...state.statusCodes, action.payload.statusCode],
      };

    case commonConstants.SHOW_ERROR_CUSTOM_SERVER_MESSAGE:
      let customErrors = [
        ...state.customErrors.filter((item) => {
          return item.statusCode != action.payload.statusCode;
        }),
      ];

      return {
        ...state,
        customErrors: [action.payload, ...customErrors],
      };

    case commonConstants.SHOW_ERROR_CONFIRM_SERVER_MESSAGE:
      return {
        ...state,
        customErrors: [],
        showConfirm: true,
        messages: [...state.messages, action.payload.message],
        statusCodes: [...state.statusCodes, action.payload.statusCode],
      };

    case commonConstants.HIDE_ERROR_CUSTOM_SERVER_MESSAGE:
      return {
        ...state,
        customErrors: [
          ...state.customErrors.filter(
            (item) => !action.payload.includes(item.statusCode),
          ),
        ],
      };

    case commonConstants.HIDE_ERROR_SERVER_MESSAGE:
      return INITIAL_SERVER_ERROR_MESSAGE_STATE;

    case commonConstants.HIDE_ERROR_CONFIRM_SERVER_MESSAGE:
      return INITIAL_SERVER_ERROR_MESSAGE_STATE;

    case authConstants.AUTH_LOGIN_REQUEST:
    case authConstants.AUTH_LOGIN_COMPLETE:
    case authConstants.OTP_CONFIRM_COMPLETE:
    case authConstants.EXPIRED_PASSWORD_CHANGE_VALUE_COMPLETE:
      return INITIAL_SERVER_ERROR_MESSAGE_STATE;

    case commonConstants.CLEAR_CUSTOM_ERRORS:
      return {
        ...state,
        customErrors: [],
      };
  }

  return state;
}

const INITIAL_FRONTEND_MESSAGE_STATE = {
  show: false,
  title: null,
  message: null,
  icon: null,
  needAssistance: false,
  actionLabel: null,
  action: null,
};

export function frontEndMessageReducer(
  state = INITIAL_FRONTEND_MESSAGE_STATE,
  action,
) {
  switch (action.type) {
    case commonConstants.SHOW_FRONTEND_MESSAGE:
      return {
        ...state,
        show: true,
        title: action?.payload?.title,
        message: action?.payload?.message,
        icon: action.payload.icon ? action.payload?.icon : null,
        needAssistance: action?.payload?.needAssistance
          ? action?.payload?.needAssistance
          : false,
        actionLabel: action?.payload?.actionLabel,
        redirectTo: action?.payload?.redirectTo,
      };

    case commonConstants.HIDE_FRONTEND_MESSAGE:
      return INITIAL_SERVER_ERROR_MESSAGE_STATE;
  }

  return state;
}
